import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { InstituteDetailsComp } from './institutedetails';
import { AddNewUser, GetProcessList, GetUserDetails, UpdateUserDetails } from '../../models/process';
import { pnkstore } from '../../stores/pnk-store';
import { useUserStore } from '../../stores/user-store';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { GetAllProject, GetAreasList, GetCitiesList, GetDistrictList, GetStatesList } from '../../models/project';
import { AddNewInstitute, AddNewLead, GetAllInstitutes, GetAllLeads, UpdateInstitute, UpdateInstituteDesc, UpdateLead, UpdateLeadDesc } from '../../models/leads';
import { GetProfileList } from '../../models/profile';
import { GetUserList } from '../../models/user';

export const InstituteDetails = () => {
    const userData = useUserStore;
    const [tabName, setTabName] = useState('Customer Details');
    const [LeadFormData, setLeadFormData] = useState({
        'chkNeedFinishingSchool': true,
        'chkPlacementAvailable': true,
        'chkRaAvailable': true,
        'chkCareHomeJobs': true,
        'txtInterviewDate': new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10).replace('T', ' '),
        'txtJoiningDate': new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10).replace('T', ' '),
    });
    const [sourceListData, setSetSourceListData] = useState(['Organic', 'Google', 'Meta']);
    const [getStateList, setGetStateList] = useState(true);
    const [stateListData, setStateListData] = useState([]);
    const [getCityList, setGetCityList] = useState(false);
    const [cityListData, setCityListData] = useState([]);
    const [getAreaList, setGetAreaList] = useState(false);
    const [areaListData, setAreaListData] = useState([]);
    const [getProfileList, setGetProfileList] = useState(true);
    const [profileListData, setProfileListData] = useState([]);
    const [getUserList, setGetUserList] = useState(true);
    const [userListData, setUserListData] = useState([]);
    const [getProjectList, setGetProjectList] = useState(false);
    const [projectList, setProjectList] = useState([]);
    const [investmentSizeList, setInvestmentSizeList] = useState([]);
    const [projectSearchObj, setProjectSearchObj] = useState({});
    const [getLeadDetails, setGetLeadDetails] = useState(false);
    const [leadDetails, setLeadDetails] = useState([]);
    const [leadSearchObj, setLeadSearchObj] = useState({});
    const [setNo, setSetNo] = useState(1);
    const [perSet, setPerSet] = useState(20);

    const [openDescriptionBox, setOpenDescriptionBox] = useState(false);
    const [openProjectDetailsBox, setOpenProjectDetailsBox] = useState(false);
    const [mode, setMode] = useState('add');
    const [addLead, setAddLead] = useState(false);
    const [editLead, setEditLead] = useState(false);
    const [updateLeadDesc, setUpdateLeadDesc] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertMsg, setAlertMsg] = useState('');
    const [statusListArray, setStatusListArray] = useState([]);
    const [interviewstatusListArray, setInterviewStatusListArray] = useState([]);
    const [joiningstatusListArray, setJoiningStatusListArray] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    const state = {
        userData: userData.getState(),
        tabName: tabName,
        mode: mode,
        addUser: addLead,
        editUser: editLead,
        openDescriptionBox: openDescriptionBox,
        openProjectDetailsBox: openProjectDetailsBox,
        leadDetails: leadDetails,
        stateListData: stateListData,
        profileListData: profileListData,
        userListData: userListData,
        investmentSizeList: investmentSizeList,
        showAlert: showAlert,
        alertMsg: alertMsg,
        alertType: alertType,
        sourceListData: sourceListData,
        statusListArray: statusListArray,
        interviewstatusListArray: interviewstatusListArray,
        joiningstatusListArray: joiningstatusListArray
    }

    useEffect(() => {
        let institute_id = params.institute_id;
        if (institute_id !== undefined && institute_id !== null && institute_id !== '' && institute_id !== 'new') {
            setMode('edit');
            setLeadSearchObj({
                'txtInstituteId': institute_id
            })
            setGetLeadDetails(true);
            setLeadFormData((prev) => ({ ...prev, ['txtInstituteId']: institute_id }));
        }
        else {

        }
    }, []);

    const HandleInputs = (e, name) => {
        let value = '';

        if (name === 'txtInterviewDate' || name === 'txtJoiningDate') {
            value = e.$d;
            value = new Date(new Date(value).getTime() - (new Date(value).getTimezoneOffset() * 60000)).toISOString().substr(0, 10).replace('T', ' ')
        }
        else {
            value = e.target.value
        }

        if (name === 'txtInstituteUprnPocMobile' || name === 'txtNursesA1' || name === 'txtNursesA2' || name === 'txtNursesB1' || name === 'txtNursesB2' || name === 'txtWinRatePercentage' || name === 'txtTotalHired' || name === 'txtTotalCvsShared' || name === 'txtTalentPoolSizeMonthly' || name === 'txtDealValuePerMonth') {
            value = value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');
            setAddLead(false);
        }

        setLeadFormData((prev) => ({ ...prev, [name]: value }));
        if (name == 'ddlLeadState') {
            setGetCityList(true)
        }
        if (name == 'ddlLeadDistrict') {
            setGetAreaList(true)
        }

        if (name === 'ddlLeadOwner') {
            PopulatePocDetails(value);
        }
    }

    const PopulatePocDetails = (val) => {
        let pocData = userListData.find(
            (item) => item.user_name === val
        );
        if (pocData) {
            setLeadFormData((prev) => ({
                ...prev,
                txtInstituteUprnPoc: pocData.user_name || '',
            }));
        }
    };

    const SaveOrUpdateLead = () => {

        let emailRegex =
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        /* =========================
           BASIC INFORMATION
        ========================== */

        if (
            !LeadFormData.txtInstituteName ||
            LeadFormData.txtInstituteName.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                txtInstituteNameErr: 'Please Enter Institute Name'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                txtInstituteNameErr: ''
            }));
        }

        if (
            !LeadFormData.ddlInstituteType ||
            LeadFormData.ddlInstituteType.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                ddlInstituteTypeErr: 'Please Select Institute Type'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                ddlInstituteTypeErr: ''
            }));
        }

        if (
            !LeadFormData.txtInstituteCountry ||
            LeadFormData.txtInstituteCountry.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                txtInstituteCountryErr: 'Please Enter Country'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                txtInstituteCountryErr: ''
            }));
        }

        if (
            !LeadFormData.txtInstituteCity ||
            LeadFormData.txtInstituteCity.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                txtInstituteCityErr: 'Please Enter City'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                txtInstituteCityErr: ''
            }));
        }

        if (
            !LeadFormData.txtInstituteLocation ||
            LeadFormData.txtInstituteLocation.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                txtInstituteLocationErr: 'Please Enter Location'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                txtInstituteLocationErr: ''
            }));
        }

        /* =========================
           POC DETAILS
        ========================== */

          // POC Name Validation
        if (
            LeadFormData.txtInstituteUprnPocName === undefined ||
            LeadFormData.txtInstituteUprnPocName === null ||
            LeadFormData.txtInstituteUprnPocName.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                txtInstituteUprnPocNameErr: 'Please Enter POC Name'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                txtInstituteUprnPocNameErr: ''
            }));
        }

        // POC Mobile Validation
        if (
            LeadFormData.txtInstituteUprnPocMobile === undefined ||
            LeadFormData.txtInstituteUprnPocMobile === null ||
            LeadFormData.txtInstituteUprnPocMobile.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                txtInstituteUprnPocMobileErr: 'Please Enter POC Mobile'
            }));
            return false;
        } else {
            if (LeadFormData.txtInstituteUprnPocMobile.trim().length !== 10) {
                setLeadFormData((prev) => ({
                    ...prev,
                    txtInstituteUprnPocMobileErr: 'Please Enter Valid Mobile Number'
                }));
                return false;
            } else {
                setLeadFormData((prev) => ({
                    ...prev,
                    txtInstituteUprnPocMobileErr: ''
                }));
            }
        }

        // POC Email Validation


        if (
            LeadFormData.txtInstituteUprnPocEmail === undefined ||
            LeadFormData.txtInstituteUprnPocEmail === null ||
            LeadFormData.txtInstituteUprnPocEmail.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                txtInstituteUprnPocEmailErr: 'Please Enter POC Email'
            }));
            return false;
        } else {
            if (emailRegex.test(LeadFormData.txtInstituteUprnPocEmail)) {
                setLeadFormData((prev) => ({
                    ...prev,
                    txtInstituteUprnPocEmailErr: ''
                }));
            } else {
                setLeadFormData((prev) => ({
                    ...prev,
                    txtInstituteUprnPocEmailErr: 'Please Enter Valid Email'
                }));
                return false;
            }
        }

        if (
            !LeadFormData.ddlLeadDepartment ||
            LeadFormData.ddlLeadDepartment.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                ddlLeadDepartmentErr: 'Please Select Department'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                ddlLeadDepartmentErr: ''
            }));
        }

        if (
            !LeadFormData.ddlLeadOwner ||
            LeadFormData.ddlLeadOwner.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                ddlLeadOwnerErr: 'Please Select Owner'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                ddlLeadOwnerErr: ''
            }));
        }



      

        /* =========================
           LANGUAGE & TRAINING
        ========================== */
        if (
            !LeadFormData.txtInstituteCoreLanguages ||
            LeadFormData.txtInstituteCoreLanguages.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                txtInstituteCoreLanguagesErr:
                    'Please Enter Core Languages'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                txtInstituteCoreLanguagesErr: ''
            }));
        }

        if (
            !LeadFormData.txtLanguageFees ||
            LeadFormData.txtLanguageFees.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                txtLanguageFeesErr: 'Please Enter Language Fees'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                txtLanguageFeesErr: ''
            }));
        }

        if (
            !LeadFormData.txtTrainerLevel ||
            LeadFormData.txtTrainerLevel.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                txtTrainerLevelErr: 'Please Select Trainer Level'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                txtTrainerLevelErr: ''
            }));
        }

        if (
            !LeadFormData.ddlModeOfTraining ||
            LeadFormData.ddlModeOfTraining.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                ddlModeOfTrainingErr:
                    'Please Select Mode Of Training'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                ddlModeOfTrainingErr: ''
            }));
        }

        if (
            !LeadFormData.txtInterviewPrepBy ||
            LeadFormData.txtInterviewPrepBy.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                txtInterviewPrepByErr:
                    'Please Select Interview Prep By'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                txtInterviewPrepByErr: ''
            }));
        }

        if (
            !LeadFormData.txtExamProvider ||
            LeadFormData.txtExamProvider.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                txtExamProviderErr:
                    'Please Select Exam Provider'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                txtExamProviderErr: ''
            }));
        }

        if (
            !LeadFormData.txtExamType ||
            LeadFormData.txtExamType.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                txtExamTypeErr: 'Please Enter Exam Type'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                txtExamTypeErr: ''
            }));
        }

        /* =========================
           STUDENT PIPELINE
        ========================== */

        // if (
        //     !LeadFormData.txtNursesA1 &&
        //     LeadFormData.txtNursesA1 !== 0
        // ) {
        //     setLeadFormData((prev) => ({
        //         ...prev,
        //         txtNursesA1Err: 'Please Enter Nurses A1'
        //     }));
        //     return false;
        // } else {
        //     setLeadFormData((prev) => ({
        //         ...prev,
        //         txtNursesA1Err: ''
        //     }));
        // }

        // if (
        //     !LeadFormData.txtNursesA2 &&
        //     LeadFormData.txtNursesA2 !== 0
        // ) {
        //     setLeadFormData((prev) => ({
        //         ...prev,
        //         txtNursesA2Err: 'Please Enter Nurses A2'
        //     }));
        //     return false;
        // } else {
        //     setLeadFormData((prev) => ({
        //         ...prev,
        //         txtNursesA2Err: ''
        //     }));
        // }

        // if (
        //     !LeadFormData.txtNursesB1 &&
        //     LeadFormData.txtNursesB1 !== 0
        // ) {
        //     setLeadFormData((prev) => ({
        //         ...prev,
        //         txtNursesB1Err: 'Please Enter Nurses B1'
        //     }));
        //     return false;
        // } else {
        //     setLeadFormData((prev) => ({
        //         ...prev,
        //         txtNursesB1Err: ''
        //     }));
        // }

        // if (
        //     !LeadFormData.txtNursesB2 &&
        //     LeadFormData.txtNursesB2 !== 0
        // ) {
        //     setLeadFormData((prev) => ({
        //         ...prev,
        //         txtNursesB2Err: 'Please Enter Nurses B2'
        //     }));
        //     return false;
        // } else {
        //     setLeadFormData((prev) => ({
        //         ...prev,
        //         txtNursesB2Err: ''
        //     }));
        // }

        /* =========================
           BUSINESS DETAILS
        ========================== */

        if (
            !LeadFormData.txtAgreementStatus ||
            LeadFormData.txtAgreementStatus.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                txtAgreementStatusErr:
                    'Please Select Agreement Status'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                txtAgreementStatusErr: ''
            }));
        }

        if (
            !LeadFormData.txtRelationshipOwner ||
            LeadFormData.txtRelationshipOwner.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                txtRelationshipOwnerErr:
                    'Please Enter Relationship Owner'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                txtRelationshipOwnerErr: ''
            }));
        }


        if (
            !LeadFormData.txtLeadSource ||
            LeadFormData.txtLeadSource.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                txtLeadSourceErr: 'Please Select Lead Source'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                txtLeadSourceErr: ''
            }));
        }




        if (
            !LeadFormData.ddlLeadStage ||
            LeadFormData.ddlLeadStage.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                ddlLeadStageErr: 'Please Select Lead Stage'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                ddlLeadStageErr: ''
            }));
        }

        if (LeadFormData.ddlLeadStage === 'Call Back') {

            if (
                LeadFormData.txtCallBackDateTime === undefined ||
                LeadFormData.txtCallBackDateTime === null ||
                LeadFormData.txtCallBackDateTime.trim() === ''
            ) {
                setLeadFormData((prev) => ({
                    ...prev,
                    txtCallBackDateTimeErr: 'Please Select Call Back Date & Time'
                }));
                return false;
            }
            else if (
                new Date(LeadFormData.txtCallBackDateTime) < new Date()
            ) {
                setLeadFormData((prev) => ({
                    ...prev,
                    txtCallBackDateTimeErr: 'Call Back Date & Time cannot be in past'
                }));
                return false;
            }
            else {
                setLeadFormData((prev) => ({
                    ...prev,
                    txtCallBackDateTimeErr: ''
                }));
            }

        }

        if (LeadFormData.ddlLeadStage === 'Onboarding') {

            if (
                LeadFormData.txtOnboardingDateTime === undefined ||
                LeadFormData.txtOnboardingDateTime === null ||
                LeadFormData.txtOnboardingDateTime.trim() === ''
            ) {
                setLeadFormData((prev) => ({
                    ...prev,
                    txtOnboardingDateTimeErr: 'Please Select Onboarding Date & Time'
                }));
                return false;
            } else {
                setLeadFormData((prev) => ({
                    ...prev,
                    txtOnboardingDateTimeErr: ''
                }));
            }

        }

        if (
            mode === 'edit' &&
            leadDetails?.length > 0 &&
            LeadFormData.ddlLeadStage !== leadDetails?.[0]?.lead_stage
        ) {
            if (LeadFormData.txtInteractionDesc === undefined || LeadFormData.txtInteractionDesc === null || LeadFormData.txtInteractionDesc === '') {
                setLeadFormData((prev) => ({
                    ...prev,
                    txtInteractionDescErr: 'Please Enter Description'
                }));
                return false;
            }
            else {
                setLeadFormData((prev) => ({
                    ...prev,
                    txtInteractionDescErr: ''
                }));
            }
        }



        /* =========================
           SAVE / UPDATE
        ========================== */

        console.log('FORM DATA => ', LeadFormData);

        if (mode === 'add') {
            setAddLead(true);
        } else {
            setEditLead(true);
        }
    };

    const ToggleDescriptionBox = () => {
        if (openDescriptionBox == true) {
            setOpenDescriptionBox(false);
        }
        else {
            setOpenDescriptionBox(true);
        }
    }

    const ToggleProjectDetailsBox = () => {
        if (openProjectDetailsBox == true) {
            setOpenProjectDetailsBox(false);
        }
        else {
            setOpenProjectDetailsBox(true);
        }
    }

    const AddDescription = () => {
        if (LeadFormData.txtLeadComment == undefined || LeadFormData.txtLeadComment == null || LeadFormData.txtLeadComment.trim() == '') {
            setLeadFormData((prev) => ({ ...prev, ['txtLeadCommentErr']: 'Please Enter Comment' }));
            return false;
        }
        else {
            setLeadFormData((prev) => ({ ...prev, ['txtLeadCommentErr']: '' }));
        }
        setUpdateLeadDesc(true);
    }

    const HandleCityListResponse = (res) => {
        if (res != false) {
            let data = res.data.districtlistresponse.rows;

            setCityListData(data);

            if (mode == 'edit') {
                setGetAreaList(true)
            }
        }
        else {
            setCityListData([]);
        }

        setGetCityList(false);
    }

    const HandleAreaListResponse = (res) => {
        if (res != false) {
            let data = res.data.arealistresponse.rows;
            setAreaListData(data);
        }
        else {
            setAreaListData([]);
        }
        setGetAreaList(false);

    }

    const HandleAddNewLeadResponse = (res) => {
        setAddLead(false);
        if (res != false) {
            console.log(res.data.instituteresponse.message.value);
            NavigateTo('institutes');
        }
        else {
            setShowAlert(true);
            setAlertType('error')
            setAlertMsg('Some Error Please Try Again');
        }
    }

    const NavigateTo = (route) => {
        navigate('/' + route, {});
    }

    const HandleGetLeadListSuccessResponse = (res) => {
        if (res != false && res != 'error') {

            setLeadDetails(res.data.leadlistresponse.rows);

            BindLeadDetails(res.data.leadlistresponse.rows[0]);
        }
        else {
            setLeadDetails([]);
        }
        setGetLeadDetails(false);
    }

    const BindLeadDetails = (leadData) => {

        setLeadFormData((prev) => ({
            ...prev,

            // BASIC DETAILS
            txtInstituteName: leadData.institute_name || '',
            ddlInstituteType: leadData.institute_type || '',
            txtInstituteCountry: leadData.institute_country || '',
            txtInstituteCity: leadData.institute_city || '',
            txtInstituteLocation: leadData.institute_location || '',

            // POC DETAILS
            txtInstituteUprnPoc: leadData.institute_uprn_poc || '',
            txtInstituteUprnPocName: leadData.institute_uprn_poc_name || '',
            txtInstituteUprnPocMobile: leadData.institute_uprn_poc_mobile || '',
            txtInstituteUprnPocEmail: leadData.institute_uprn_poc_email || '',

            // LANGUAGE & TRAINING
            txtInstituteCoreLanguages: Array.isArray(leadData.institute_core_languages)
                ? leadData.institute_core_languages.join(', ')
                : '',

            txtLanguageFees: leadData.language_fees || '',
            txtTrainerLevel: leadData.trainer_level || '',
            ddlModeOfTraining: leadData.mode_of_training || '',

            chkNeedFinishingSchool: leadData.need_finishing_school || false,

            txtInterviewPrepBy: leadData.interview_prep_by || '',

            txtExamProvider: leadData.exam_provider || '',
            txtExamType: leadData.exam_type || '',

            txtB1BatchGraduatingMonth:
                leadData.b1_batch_graduating_month || '',

            txtB2BatchGraduatingMonth:
                leadData.b2_batch_graduating_month || '',

            chkPlacementAvailable:
                leadData.placement_available || false,

            chkRaAvailable:
                leadData.ra_available || false,

            chkCareHomeJobs:
                leadData.care_home_jobs || false,

            txtPlacementDocFees:
                leadData.placement_doc_fees || '',

            // STUDENT PIPELINE
            txtNursesA1: leadData.nurses_a1 || 0,
            txtNursesA2: leadData.nurses_a2 || 0,
            txtNursesB1: leadData.nurses_b1 || 0,
            txtNursesB2: leadData.nurses_b2 || 0,

            // BUSINESS DETAILS
            txtAgreementStatus:
                leadData.agreement_status || '',

            ddlLeadStage:
                leadData.lead_stage || '',

            txtLeadSource:
                leadData.lead_source || '',

            txtRelationshipOwner:
                leadData.relationship_owner || '',

            txtLastContactDate:
                leadData.last_contact_date || '',

            txtStageChangeDate:
                leadData.stage_change_date || '',

            txtDealValuePerMonth:
                leadData.deal_value_per_month || '',

            txtTalentPoolSizeMonthly:
                leadData.talent_pool_size_monthly || '',

            txtStudentTechLevel:
                leadData.student_tech_level || '',

            txtTotalCvsShared:
                leadData.total_cvs_shared || '',

            txtTotalHired:
                leadData.total_hired || '',

            txtWinRatePercentage:
                leadData.win_rate_percentage || '',

            // OWNER DETAILS
            ddlLeadDepartment:
                leadData.lead_owner_profile || '',

            ddlLeadOwner:
                leadData.lead_owner_name || '',

            txtLeadDesc:
                leadData.lead_description || '',

            // AUDIT DETAILS
            txtInstituteAddedBy:
                leadData.institute_added_by || '',

            txtInstituteAddedOn:
                leadData.institute_added_on || '',
            txtCallBackDateTime:
                leadData.call_back_date_time || '',
            txtOnboardingDateTime:
                leadData.onboarding_date_time || '',
        }));
    };

    const HandleCloseAlertMsg = (type) => {
        setTimeout(() => {
            setShowAlert(false);
            setAlertType('');
            setAlertMsg('');

        }, 3000)

    }

    const HandleUpdateLeadResponse = (res) => {
        //  console.log(res);

        if (res != false) {
            setGetLeadDetails(true);
            setShowAlert(true);
            setAlertType('success')
            setAlertMsg(res.data.instituteupdateresponse.message.value);
        }
        else {
            setShowAlert(true);
            setAlertType('error')
            setAlertMsg('Please Try Again');
        }

        setLeadFormData((prev) => ({
            ...prev,
            txtInteractionDesc: ''
        }));


        setEditLead(false);
    }

    const HandleStateListResponse = (res) => {
        //  console.log(res.data.statelistresponse.rows);
        if (res != false) {
            setStateListData(res.data.statelistresponse.rows);
        }
        else {
            setStateListData([]);
        }
        setGetStateList(false)
    }


    const HandleGetProfilesListSuccessResponse = (res) => {
        if (res != false && res != 'error') {
            console.log(res);
            let profileListData = res.data.profilelistresponse.rows
            setProfileListData(profileListData);
        }
        else {
            setProfileListData([]);
        }
        setGetProfileList(false);
    }

    const HandleGetUsersListSuccessResponse = (res) => {
        if (res != false && res != 'error') {
            console.log(res);
            let usersListData = res.data.userlistresponse.rows
            setUserListData(usersListData);
        }
        else {
            setUserListData([]);
        }
        setGetUserList(false);
    }

    const GetProjectDetails = () => {
        ToggleProjectDetailsBox();
    }

    const HandleUpdateLeadDescResponse = (res) => {
        if (mode == 'edit') {
            setGetLeadDetails(true);
        }
        setLeadFormData((prev) => ({ ...prev, ['txtLeadComment']: '' }));
        ToggleDescriptionBox();
        setUpdateLeadDesc(false);
    }












    return (
        <Box>
            <InstituteDetailsComp
                mystate={state}
                HandleInputs={HandleInputs}
                NavigateTo={NavigateTo}
                cityListData={cityListData}
                areaListData={areaListData}
                projectList={projectList}
                LeadFormData={LeadFormData}
                SaveOrUpdateLead={SaveOrUpdateLead}
                ToggleDescriptionBox={ToggleDescriptionBox}
                AddDescription={AddDescription}
                HandleCloseAlertMsg={HandleCloseAlertMsg}
                GetProjectDetails={GetProjectDetails}
                ToggleProjectDetailsBox={ToggleProjectDetailsBox}
            />
            {((getUserList === true) ? GetUserList(pnkstore, {}, userData.getState().token, HandleGetUsersListSuccessResponse) : "")}
            {((getProfileList === true) ? GetProfileList(pnkstore, {}, userData.getState().token, HandleGetProfilesListSuccessResponse) : "")}
            {((getStateList === true) ? GetStatesList(pnkstore, userData.getState().token, HandleStateListResponse) : "")}
            {((getCityList === true) ? GetDistrictList(pnkstore, LeadFormData.ddlLeadState, userData.getState().token, HandleCityListResponse) : "")}
            {((getAreaList === true) ? GetAreasList(pnkstore, LeadFormData.ddlLeadDistrict, userData.getState().token, HandleAreaListResponse) : "")}
            {((addLead === true) ? AddNewInstitute(pnkstore, LeadFormData, userData.getState().token, HandleAddNewLeadResponse) : "")}
            {((editLead === true) ? UpdateInstitute(pnkstore, LeadFormData, userData.getState().token, HandleUpdateLeadResponse) : "")}
            {((getLeadDetails === true) ? GetAllInstitutes(pnkstore, leadSearchObj, userData.getState().token, HandleGetLeadListSuccessResponse) : "")}
            {((updateLeadDesc === true) ? UpdateInstituteDesc(pnkstore, LeadFormData, userData.getState().token, HandleUpdateLeadDescResponse) : "")}
        </Box>
    )
}